import {
  useController,
  type FieldValues,
  type UseControllerProps,
} from "react-hook-form";
import {
  Autocomplete,
  type IAutocompleteProps,
} from "@components/inputs/Autocomplete/Autocomplete";

type TFormAutocompleteProps<T extends FieldValues> = IAutocompleteProps &
  UseControllerProps<T>;

export const FormAutocomplete = <T extends FieldValues>({
  name,
  control,
  ...rest
}: TFormAutocompleteProps<T>) => {
  const controller = useController({
    name,
    control,
  });

  const {
    field,
    fieldState: { error },
  } = controller;

  const { ref: fieldRef, ...fieldRest } = field;

  return (
    <Autocomplete
      {...rest}
      {...fieldRest}
      inputRef={fieldRef}
      error={error?.message}
      {...(rest.disabled ? { disabled: true } : {})}
    />
  );
};
